import { InquiryInterface } from "@/model/views/inquiry/Inquiry";
import { INQUIRY_TYPE_MASTER } from "@/model/components/inquiry/InquiryType";

const mapEstimate: Function = (f: InquiryInterface): object => {
  switch (true) {
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.REQUEST_ESTIMATE:
      return {
        type: f.estimateDetails.type + f.estimateDetails.text,
        numberOfPrints: f.estimateDetails.numberOfPrints,
        peoples: f.estimateDetails.numberOfPeople,
        logoFile1: f.estimateDetails.logoFile1,
        logoFile2: f.estimateDetails.logoFile2,
        question: f.estimateDetails.message
      };
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.REQUEST_SAMPLE:
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.OTHER:
      return {
        type: "",
        numberOfPrints: "",
        peoples: "",
        logoFile1: "",
        logoFile2: "",
        question: ""
      };
    default:
      throw new Error("Unexpected route was called!");
  }
};

const mapShippingAddress: Function = (f: InquiryInterface): object => {
  switch (true) {
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.REQUEST_SAMPLE:
      return {
        deliveryZipcode: f.shippingAddress.zipcode,
        deliveryAddress: f.shippingAddress.address
      };
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.REQUEST_ESTIMATE:
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.OTHER:
      return {
        deliveryZipcode: "",
        deliveryAddress: ""
      };
    default:
      throw new Error("Unexpected route was called!");
  }
};

const mapInquiryDetail: Function = (f: InquiryInterface): object => {
  switch (true) {
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.OTHER:
      return {
        content: f.inquiryDetail.detail
      };
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.REQUEST_ESTIMATE:
    case f.inquiryType.inquiryType === INQUIRY_TYPE_MASTER.REQUEST_SAMPLE:
      return {
        content: ""
      };
    default:
      throw new Error("Unexpected route was called!");
  }
};

const map: Function = (f: InquiryInterface): object => {
  return {
    inquiryType: f.inquiryType.inquiryType,
    customerName: f.orderInformation.name,
    customerKana: f.orderInformation.kana,
    customerCompany: f.orderInformation.company,
    customerTel: f.orderInformation.tel,
    customerEmail: f.orderInformation.email,
    ...mapEstimate(f),
    ...mapShippingAddress(f),
    ...mapInquiryDetail(f)
  };
};

export default {
  map
};
